import React from 'react';
import { Star, Quote, MapPin } from 'lucide-react';
type Testimonial = {
  name: string;
  location: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  name: 'María González',
  location: 'Houston, TX',
  quote: 'Por fin entiendo cómo proteger a mis hijos y ahorrar al mismo tiempo. Me explicaron todo con paciencia y sin presión.'
}, {
  name: 'Carlos Ramírez',
  location: 'Miami, FL',
  quote: 'Nunca me enseñaron esto en la escuela. Ahora mi dinero crece libre de impuestos y tengo un plan de retiro real.'
}, {
  name: 'Daniela Torres',
  location: 'Phoenix, AZ',
  quote: 'Tranquilidad total. Sé que si algo me pasa, mi familia estará protegida. Ojalá lo hubiera hecho antes.'
}, {
  name: 'José Martínez',
  location: 'Los Ángeles, CA',
  quote: 'El proceso fue rápido y claro. Me ayudaron a salir de la carrera de las ratas y a pensar en mi legado.'
}, {
  name: 'Ana Beltrán',
  location: 'Chicago, IL',
  quote: 'Me encantó que todo fuera personalizado a mi presupuesto. Empecé con un monto pequeño y ya veo resultados.'
}, {
  name: 'Roberto Díaz',
  location: 'San Antonio, TX',
  quote: 'Tenía miedo de que fuera muy caro, pero me sorprendió lo accesible que es. 100% recomendado.'
}, {
  name: 'Lucía Fernández',
  location: 'Orlando, FL',
  quote: 'Aprendí más en una llamada que en años de trabajo. Ahora tengo control sobre mi futuro financiero.'
}, {
  name: 'Miguel Ángel Soto',
  location: 'Las Vegas, NV',
  quote: 'El agente fue honesto y profesional. No me vendió humo, me dio una estrategia real para mi familia.'
}, {
  name: 'Patricia Núñez',
  location: 'Dallas, TX',
  quote: 'Me sentí escuchada y entendida. Por primera vez tengo un ahorro que crece y que me protege.'
}, {
  name: 'Fernando Castro',
  location: 'Atlanta, GA',
  quote: 'La mejor decisión financiera que he tomado. Mi dinero por fin trabaja para mí y no al revés.'
}, {
  name: 'Gabriela Ríos',
  location: 'Denver, CO',
  quote: 'Todo claro, sin letra pequeña. Me explicaron cómo retirar mi dinero libre de impuestos en el futuro.'
}, {
  name: 'Andrés Mendoza',
  location: 'Charlotte, NC',
  quote: 'Lo recomiendo a todos mis amigos. Es la herramienta que ojalá nuestros padres hubieran conocido.'
}];
function TestimonialCard({
  t
}: {
  t: Testimonial;
}) {
  return <article className="w-80 flex-shrink-0 bg-white rounded-xl shadow-sm border border-gray-100 p-6 mx-3" data-id="element-147">
      <Quote className="w-8 h-8 text-brand-green/30 mb-3" aria-hidden="true" data-id="element-148" />
      <div className="flex gap-1 mb-4" aria-label="Calificación de 5 estrellas" data-id="element-149">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" aria-hidden="true" data-id="element-150" />)}
      </div>
      <p className="text-gray-600 leading-relaxed mb-6 text-sm" data-id="element-151">"{t.quote}"</p>
      <div data-id="element-152">
        <p className="font-semibold text-brand-navy text-sm" data-id="element-153">{t.name}</p>
        <p className="text-gray-500 text-xs flex items-center gap-1 mt-0.5" data-id="element-154">
          <MapPin className="w-3 h-3 text-brand-green" aria-hidden="true" data-id="element-155" />
          {t.location}
        </p>
      </div>
    </article>;
}
export function Testimonials() {
  // Duplicate the list so the marquee loops seamlessly
  const loop = [...testimonials, ...testimonials];
  return <section id="testimonios" className="py-20 bg-brand-light overflow-hidden" aria-labelledby="testimonios-title" data-id="element-156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-14" data-id="element-157">
        <h2 id="testimonios-title" className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-158">
          Lo que dicen las familias que ya dieron el paso
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-159">
          Cientos de personas en todo Estados Unidos ya están construyendo su
          legado y protegiendo su futuro. Estas son algunas de sus historias.
        </p>
      </div>

      {/* Marquee */}
      <div className="relative" data-id="element-160">
        {/* Fade edges */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-brand-light to-transparent z-10" data-id="element-161" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-brand-light to-transparent z-10" data-id="element-162" />

        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]" data-id="element-163">
          {loop.map((t, i) => <TestimonialCard key={i} t={t} data-id="element-164" />)}
        </div>
      </div>
    </section>;
}